import type { InferResponseType } from 'hono/client';
import { Mail, Phone } from 'lucide-react';

import { StarRating } from './star-rating';

import type { api } from '~/lib/api';
import { formatPhone } from '~/lib/format-phone';

type ApplicationsResponse = InferResponseType<
  (typeof api.api.org)[':orgId']['department'][':deptId']['jobs'][':jobId']['applications']['$get']
>;
type ApplicationItem = ApplicationsResponse['applications'][number];

type ApplicationCardProps = {
  application: ApplicationItem;
  score?: number;
  onClick: () => void;
};

export function ApplicationCard({
  application,
  score,
  onClick
}: ApplicationCardProps): React.ReactNode {
  const { candidate } = application;

  return (
    <button
      type="button"
      className="w-full cursor-pointer rounded-lg border border-border bg-card p-3 text-left shadow-sm transition-colors hover:bg-accent"
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="truncate text-sm font-medium text-foreground">{candidate.name}</p>
        {score !== undefined && (
          <span className="shrink-0 rounded-md bg-blue-100 px-1.5 py-0.5 text-xs font-medium text-blue-700">
            {score.toFixed(1)}
          </span>
        )}
      </div>
      <div className="mt-1 flex items-center gap-1 text-xs text-muted-foreground">
        <Mail className="shrink-0 size-3" />
        <span className="truncate">{candidate.email}</span>
      </div>
      {candidate.phoneNumber && (
        <div className="mt-0.5 flex items-center gap-1 text-xs text-muted-foreground">
          <Phone className="shrink-0 size-3" />
          <span className="truncate">
            {formatPhone(candidate.phoneNumber, candidate.phoneCountryCode)}
          </span>
        </div>
      )}
      {application.rating !== null && (
        <div className="mt-1.5 text-xs">
          <StarRating rating={application.rating} />
        </div>
      )}
    </button>
  );
}
